import React from 'react';
import {
  ContentTiles,
  ContentTilesProps,
  ContentTilesTile,
} from '@noths/polaris-client-ribbons-design-system';
import { getContentstackImageURL } from '@noths/polaris-client-utils';

import {
  ItemsTrackingContext,
  trackItemsImpression,
} from 'src/tracking/common/trackItemsImpression';
import { trackLinkClick } from 'src/tracking/common/trackLinkClick';
import { ContentTileSerializedTile } from '../../../content/blocks/contentTiles/types';
import { setFeaturedProductParamOnURL } from '../../../utils/setFeaturedProductParamOnURL';
import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './ContentTilesBlock.style';

export interface ContentTilesBlockProps extends Omit<ContentTilesProps, 'tiles'> {
  trackingTitle: string;
  trackingPosition?: number;
  tiles: ContentTileSerializedTile[];
}

export const ContentTilesBlock = ({
  trackingPosition,
  trackingTitle,
  tiles,
}: ContentTilesBlockProps) => {
  const trackingContext: ItemsTrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Content tiles',
    numberOfItems: tiles.length,
  };

  return (
    <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsXL={10}>
      <ContentTiles
        tiles={tiles.map(
          ({ imageSrc, ...tile }) =>
            ({
              ...tile,
              // @ts-ignore - Could not resolve this error: "Type error: Binding element 'width' implicitly has an 'any' type."
              imageSrc: ({ width, height, aspectRatio }) =>
                getContentstackImageURL(imageSrc, width, { aspectRatio, height }),
            } as ContentTilesTile),
        )}
        onVisible={() => tiles.length > 0 && trackItemsImpression(trackingContext)}
        onTileClick={(e, { index }) => {
          const tile = tiles[index];

          if (tile.featuredProductCode) {
            e.currentTarget.href = setFeaturedProductParamOnURL(
              e.currentTarget.href,
              tile.featuredProductCode,
            );
          }

          trackLinkClick(e, {
            ...trackingContext,
            link: { index, name: tile.title, href: e.currentTarget.href },
            actionName: 'Tile click',
          });
        }}
      />
    </BlockContainer>
  );
};

export type { ContentTilesProps };
